"use client";

import AiLabel from "@/components/ai-label";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import PodcastPlayButton from "../podcast-play-button";
import TeaserHeading from "../teaser-heading";

const Podcast = ({
  podcast,
  compactMode = false,
  darkMode = false,
  fontWeight = "font-semibold",
}: {
  podcast: Content.PodcastEpisode;
  compactMode?: boolean;
  darkMode?: boolean;
  fontWeight?: string;
}) => {
  const title = podcast.fields.teaserTitle || podcast.fields.title;
  const image = podcast.fields.teaserImage || podcast.fields.image;

  return (
    <Link
      href={`/podd/${podcast.fields.slug}`}
      className={classNames(
        "cursor-pointer flex group relative  ",
        compactMode ? "" : "",
        darkMode ? "border-black-300 bg-black-400 text-white-500 p-4" : "",
      )}
    >
      <div
        className={classNames(
          "relative bg-sand-600 mr-4",
          compactMode
            ? "w-[107px] h-[60px] md:w-[65px] md:h-[37px]"
            : "w-[107px] h-[60px] md:w-[150px] md:h-[84px] ",
        )}
      >
        {image?.fields.file?.url && (
          <Image
            fill
            sizes={createImageSizes({
              mobile: "12vw",
              tablet: "12vw",
              desktop: "12vw",
            })}
            src={createImageUrl(image.fields.file.url, {
              crop: "16:9",
            })}
            alt={image.fields.alt || ""}
          />
        )}
        <AiLabel image={image} size="sm" />
      </div>

      <div className={classNames("flex-1", compactMode ? "" : "")}>
        {title && (
          <TeaserHeading
            text={title}
            className={classNames(
              "break-words group-hover:underline",
              fontWeight ? fontWeight : "font-semibold",
              compactMode ? "text-base" : "text-lg lg:text-xl pr-4",
            )}
          />
        )}

        {podcast.fields.media?.mediaUrl && (
          <PodcastPlayButton small podcast={podcast} />
        )}
      </div>
    </Link>
  );
};

export default Podcast;
